import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=35470045&scoped=true"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&id=35470045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35470045",
  null
  
)

export default component.exports